export function toPascalCase(text) {
    text = text.replaceAll('_', ' ')
        .replaceAll('-', ' ')
    const words = text.split(' ')
    text = words.reduce((carry, word) =>  {
        return word ? carry + ' ' + (word[0].toUpperCase() + word.slice(1).toLocaleLowerCase('en-US')) : carry
    },'')
    return text
}